module.exports = __webpack_public_path__ + "img/m9.fd3de4c.jpg";